// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3lXoy","header":"Messages_header__3rdzc"};